var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimesheetApproved = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.34331 4.34331C5.84371 2.84291 7.87868 2 10.0006 2C12.1224 2 14.1574 2.84291 15.6578 4.34331C17.1582 5.84371 18.0011 7.87868 18.0011 10.0006C18.0011 12.1224 17.1582 14.1574 15.6578 15.6578C14.1574 17.1582 12.1224 18.0011 10.0006 18.0011C7.87868 18.0011 5.84371 17.1582 4.34331 15.6578C2.84291 14.1574 2 12.1224 2 10.0006C2 7.87868 2.84291 5.84371 4.34331 4.34331ZM10.0006 3.5C8.2765 3.5 6.62306 4.18488 5.40397 5.40397C4.18488 6.62306 3.5 8.2765 3.5 10.0006C3.5 11.7246 4.18488 13.3781 5.40397 14.5971C6.62306 15.8162 8.2765 16.5011 10.0006 16.5011C11.7246 16.5011 13.3781 15.8162 14.5971 14.5971C15.8162 13.3781 16.5011 11.7246 16.5011 10.0006C16.5011 8.2765 15.8162 6.62306 14.5971 5.40397C13.3781 4.18488 11.7246 3.5 10.0006 3.5ZM13.6989 7.43117C14.013 7.70114 14.0489 8.17466 13.7789 8.48881L10.3419 12.4884C10.2495 12.5959 10.1333 12.6709 10.0077 12.7121C9.72768 12.8048 9.40702 12.7264 9.20283 12.4888L7.43117 10.4271C7.16121 10.113 7.19703 9.63946 7.51119 9.3695C7.82534 9.09954 8.29886 9.13536 8.56883 9.44952L9.77221 10.8499L12.6413 7.51119C12.9112 7.19703 13.3847 7.16121 13.6989 7.43117Z",
  fill: "#46CC88"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimesheetApproved);
export default ForwardRef;